import { useQuery } from '@tanstack/react-query';
import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getDocumentsQueryKey,
  getDocumentDetailQueryKey,
  listDocuments,
  getDocumentById,
  type ListDocumentsFilters,
} from '../api/documents.client.js';

export function useDocuments(filters: ListDocumentsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  const query = useQuery({
    queryKey: getDocumentsQueryKey(workspaceId, filters),
    queryFn: () => listDocuments(filters),
    enabled: scope !== null,
    staleTime: 30_000,
  });

  return {
    documents: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useDocumentDetail(documentId: string | undefined) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  const query = useQuery({
    queryKey: getDocumentDetailQueryKey(workspaceId, documentId ?? ''),
    queryFn: () => getDocumentById(documentId!),
    enabled: scope !== null && documentId !== undefined && documentId !== '',
    staleTime: 30_000,
  });

  return {
    document: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
